module.exports = __webpack_public_path__ + "static/img/scsf.188284a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scsf.png
// module id = 1cyq
// module chunks = 1